{
 "z02-mole-berths": {
  "perspective": [
   380,
   880,
   0.84,
   1.04
  ],
  "ground": [
   640,
   600
  ],
  "haze": [
   860,
   160
  ],
  "fog": 0.1
 },
 "z02-bonded-warehouse": {
  "perspective": [
   380,
   800,
   0.9,
   1.02
  ],
  "ground": [
   760,
   600
  ],
  "haze": [
   700,
   90
  ],
  "fog": 0.06
 },
 "z02-rope-walk": {
  "perspective": [
   260,
   880,
   0.86,
   1.04
  ],
  "ground": [
   700,
   560
  ],
  "haze": [
   700,
   120
  ],
  "fog": 0.1
 },
 "z02-sale-court": {
  "perspective": [
   360,
   880,
   0.94,
   1.06
  ],
  "ground": [
   768,
   560
  ],
  "haze": [
   380,
   110
  ],
  "fog": 0.08
 }
}
